import React from 'react';

interface HeroTeslaRobotProps {
  className?: string;
}

const HeroTeslaRobot: React.FC<HeroTeslaRobotProps> = ({ className = '' }) => {
  return (
    <div className={`hero-robot-container ${className}`}>
      <svg
        width="200"
        height="300"
        viewBox="0 0 200 300"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hero-robot"
      >
        {/* Head */}
        <path
          d="M100 30C79.0132 30 62 47.0132 62 68V86C62 106.987 79.0132 124 100 124C120.987 124 138 106.987 138 86V68C138 47.0132 120.987 30 100 30Z"
          fill="#1A1A1A"
        />
        
        {/* Face plate */}
        <path
          d="M100 40C84.536 40 72 52.536 72 68V86C72 101.464 84.536 114 100 114C115.464 114 128 101.464 128 86V68C128 52.536 115.464 40 100 40Z"
          fill="#2C2C2C"
        />
        
        {/* Eyes */}
        <path
          d="M84 70C87.3137 70 90 67.3137 90 64C90 60.6863 87.3137 58 84 58C80.6863 58 78 60.6863 78 64C78 67.3137 80.6863 70 84 70Z"
          fill="#00F7FF"
        />
        <path
          d="M116 70C119.314 70 122 67.3137 122 64C122 60.6863 119.314 58 116 58C112.686 58 110 60.6863 110 64C110 67.3137 112.686 70 116 70Z"
          fill="#00F7FF"
        />
        
        {/* Neck */}
        <rect x="90" y="124" width="20" height="16" fill="#1A1A1A" />
        
        {/* Body */}
        <path
          d="M70 140H130C135.523 140 140 144.477 140 150V200C140 205.523 135.523 210 130 210H70C64.4772 210 60 205.523 60 200V150C60 144.477 64.4772 140 70 140Z"
          fill="#1A1A1A"
        />
        
        {/* Chest plate */}
        <path
          d="M80 150H120C122.209 150 124 151.791 124 154V196C124 198.209 122.209 200 120 200H80C77.7909 200 76 198.209 76 196V154C76 151.791 77.7909 150 80 150Z"
          fill="#2C2C2C"
        />
        
        {/* Arms */}
        <rect x="40" y="140" width="20" height="60" rx="10" fill="#1A1A1A" />
        <rect x="140" y="140" width="20" height="60" rx="10" fill="#1A1A1A" />
        
        {/* Hands */}
        <rect x="35" y="200" width="30" height="15" rx="7.5" fill="#2C2C2C" />
        <rect x="135" y="200" width="30" height="15" rx="7.5" fill="#2C2C2C" />
        
        {/* Legs */}
        <rect x="80" y="210" width="16" height="60" rx="8" fill="#1A1A1A" />
        <rect x="104" y="210" width="16" height="60" rx="8" fill="#1A1A1A" />
        
        {/* Feet */}
        <path
          d="M75 270H96C96 264.477 91.5228 260 86 260H85C79.4772 260 75 264.477 75 270Z"
          fill="#2C2C2C"
        />
        <path
          d="M104 270H125C125 264.477 120.523 260 115 260H114C108.477 260 104 264.477 104 270Z"
          fill="#2C2C2C"
        />
        
        {/* Glowing effects */}
        <circle cx="84" cy="64" r="6" fill="#00F7FF" opacity="0.5">
          <animate 
            attributeName="opacity" 
            values="0.5;0.8;0.5" 
            dur="2s" 
            repeatCount="indefinite" 
          />
        </circle>
        <circle cx="116" cy="64" r="6" fill="#00F7FF" opacity="0.5">
          <animate 
            attributeName="opacity" 
            values="0.5;0.8;0.5" 
            dur="2s" 
            repeatCount="indefinite" 
          />
        </circle>
        
        {/* Chest light */}
        <circle cx="100" cy="175" r="8" fill="#00F7FF" opacity="0.7">
          <animate 
            attributeName="opacity" 
            values="0.7;1;0.7" 
            dur="3s" 
            repeatCount="indefinite" 
          />
        </circle>
        
        {/* Circuit lines */}
        <path
          d="M84 80C84 80 90 90 100 90C110 90 116 80 116 80"
          stroke="#00F7FF"
          strokeWidth="1"
          strokeOpacity="0.5"
        />
        
        <path
          d="M90 175H110"
          stroke="#00F7FF"
          strokeWidth="1"
          strokeOpacity="0.5"
        />
        
        <path
          d="M100 183V167"
          stroke="#00F7FF"
          strokeWidth="1"
          strokeOpacity="0.5"
        />
        
        {/* Animated elements */}
        <rect x="76" y="160" width="48" height="2" fill="#00F7FF" opacity="0.3">
          <animate
            attributeName="y"
            values="160;190;160"
            dur="5s"
            repeatCount="indefinite"
          />
        </rect>
        
        <rect x="76" y="165" width="48" height="1" fill="#00F7FF" opacity="0.2">
          <animate
            attributeName="y"
            values="165;185;165"
            dur="4s"
            repeatCount="indefinite"
          />
        </rect>
      </svg>
      
      {/* Glow effect */}
      <div className="hero-robot-glow"></div>
    </div>
  );
};

export default HeroTeslaRobot;
